import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

pdfMake.fonts = {
  Roboto: {
    normal: 'Roboto-Regular.ttf',
    bold: 'Roboto-Medium.ttf',
    italics: 'Roboto-Italic.ttf',
    bolditalics: 'Roboto-MediumItalic.ttf'
  },
  NotoSansKr: {
    normal: window.location.origin + '/fonts/NotoSansKR-Regular.ttf',
    bold: window.location.origin + '/fonts/NotoSansKR-Black.ttf',
    italics: window.location.origin + '/fonts/NotoSansKR-Regular.ttf',
    bolditalics: window.location.origin + '/fonts/NotoSansKR-Black.ttf',
  },
}

export const getPdfMake = () => {
  return pdfMake;
}